module.exports = __webpack_public_path__ + "baroquescript-webfont.e7224d887e229dffd03e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/baroquescript-webfont.ttf
// module id = 633
// module chunks = 1